import { Permission, PermissionString, Role } from "../dtos.permissions";
import { AbstractRoleBasedPermissionService, ContextPermissions } from "./abstract.roleBased.permission.service";

/** 
 * Implementation of the {@link PermissionService }
 * This implementation requires you to implement the getMergedPermissions to retrieve the permissions 
 * corresponding to a user (usually stored in its loginData, and might be dependant of the permissionContext)
 * kept temporarily for backward compatibility 
 * @deprecated
 */
export abstract class AbstractPermissionService<LoginData, PermissionContext, PS extends PermissionString = PermissionString> extends AbstractRoleBasedPermissionService<LoginData, PermissionContext, PS> {

    /**
     * Returns the list of all the highest permissions without duplicates for the user - You can override it.
     * @param loginData Uid of the user
     * @param permissionContext (optional) dictionary of key:entityType / value: entityUid
     * @returns Permission[]
     */
    public abstract getMergedPermissions(loginData: LoginData, permissionContext?: PermissionContext): Permission[];

    /**
     * Get user permissions for context
     */
    public override getContextPermissions(loginData: LoginData, permissionContext?: PermissionContext): ContextPermissions {
        return {
            permissions: this.getMergedPermissions(loginData, permissionContext),
            roles: []
        };
    }

    /** @returns an empty array */
    public override getUserRoles(loginData: LoginData, permissionContext?: PermissionContext): Role[] {
        return [];
    }

}